import React from 'react';

// File imported
import HomeBlogPageHeader from "../../components/PageHeader/HomeBlog";

const ContentHomeBlogPage = () => {
    return (
        <div className="content-body section custom-scroll">
            <div className="section-wrap section">
                <HomeBlogPageHeader/>
            </div>
        </div>
    );
};

export default ContentHomeBlogPage;
